module.exports = __webpack_public_path__ + "static/img/webInstavice.af2ffc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/webInstavice.png
// module id = oj2t
// module chunks = 1